import React from "react";
import InputField from "./field/Input";
import TextareaField from "./field/Textarea";
import SelectField from "./field/Select";
import SwitchField from "./field/Switch";
import EmailField from "./field/Email";
import PhoneField from "./field/Phone";
import RelationField from "./field/Relation";

const FormField = ({ type, name, label, value, options, error, readOnly, onChange }) => {
  switch (type) {
    case "text":
    case "password":
    case "url":
      return <InputField type={type} name={name} label={label} value={value} error={error} onChange={onChange} />;
    case "textarea":
      return <TextareaField name={name} label={label} value={value} error={error} onChange={onChange} />;
    case "select":
      return <SelectField name={name} label={label} value={value} options={options} error={error} onChange={onChange} />;
    case "switch":
      return <SwitchField name={name} label={label} value={value} onChange={onChange} />;
    case "email":
      return <EmailField name={name} label={label} value={value} error={error} readOnly={readOnly} onChange={onChange} />;
    case "phone":
      return <PhoneField name={name} label={label} value={value} error={error} onChange={onChange} />;
    case "relation": 
      return <RelationField name={name} label={label} value={value} error={error} onChange={onChange} />;
    default:
      return null;
  }
};

export default FormField;
